import { AuthTokenFactory, AuthFactory } from '@app/core/services';
import { throwIfAlreadyLoaded } from './guards/module-import.guard';
var ɵ0 = AuthTokenFactory, ɵ1 = AuthFactory;
var CoreModule = /** @class */ (function () {
    function CoreModule(parentModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
    return CoreModule;
}());
export { CoreModule };
export { ɵ0, ɵ1 };
